import { Link } from "react-router-dom";
import React, { useEffect } from "react";

export default function Ilo() {

  const currentYear = new Date().getFullYear();
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-800 font-sans">

      {/* Hero */}
      <section className="relative overflow-hidden bg-white">


        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid md:grid-cols-2 gap-16 items-center">
          <div>
            <img
              src="/ilo 01 png.png"
              alt="ILO"
              className="h-20 md:h-24 w-auto object-contain mb-8 rounded-xl"
            />
            <p className="uppercase tracking-[0.3em] text-xs text-amber-600 mb-5">
              Inner Light On
            </p>
            <h1 className="text-4xl md:text-5xl font-light leading-tight mb-6 tracking-tight text-slate-800">
              Quiet the noise.<br />
              <span className="text-amber-600">Get back to yourself.</span>
            </h1>
            <p className="text-slate-600 text-base md:text-lg leading-8 mb-3">
              ILO is a two-minute clarity experience powered by adaptive technology,
              designed to help you reset, refocus, and return to a calm, stable state.
            </p>
            <p className="text-slate-500 text-sm mb-8">Minimal data usage. Privacy-first experience.</p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#what-is-ilo"
                className="bg-amber-500 text-white font-semibold px-7 py-3 rounded-xl hover:opacity-90 transition"
              >
                Learn More
              </a>
              <Link
                to="/#contact"
                className="border border-slate-300 text-slate-700 px-7 py-3 rounded-xl hover:bg-slate-50 transition"
              >
                Get in Touch
              </Link>
            </div>
          </div>

          {/* ILO App Screenshots */}
          <div className="flex justify-center md:justify-end gap-4 items-start">
            <div className="relative mt-6">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-purple-500/20 to-pink-500/20 blur-2xl scale-110" />
              <img
                src="/ilo-1.png"
                alt="ILO App Screen 1"
                className="relative w-56 md:w-60 rounded-3xl shadow-2xl border border-slate-200"
              />
            </div>
            <div className="relative">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-pink-500/20 to-amber-500/20 blur-2xl scale-110" />
              <img
                src="/Main dashboard.png"
                alt="ILO App Screen 2"
                className="relative w-56 md:w-60 rounded-3xl shadow-2xl border border-slate-200"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What is ILO */}
      <section id="what-is-ilo" className="bg-[#f6f9fc] border-t border-slate-200">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="text-center mb-14">
            <p className="text-amber-600 uppercase tracking-[0.2em] text-xs font-semibold mb-3">What is ILO?</p>
            <h2 className="text-3xl md:text-4xl font-light mb-6">
              A digital clarity experience. AI-powered. Privacy-first.
            </h2>
            <p className="text-slate-600 leading-8 max-w-3xl mx-auto">
              ILO is a digital clarity experience and AI-powered wellness chatbot designed to reduce
              mental clutter in real time. It is not a traditional app. It is not a structured or
              rule-based chatbot experience. It is not therapy. It is a minimal, intelligent system
              that meets you exactly where you are — and helps you return to yourself.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5">
            {[
              {
                title: "No Memory",
                icon: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16",
                desc: "Every session is completely fresh. Nothing is stored, remembered, or tracked. Ever.",
              },
              {
                title: "No Advice",
                icon: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636",
                desc: "ILO does not instruct. It creates space for clarity to emerge naturally.",
              },
              {
                title: "No Noise",
                icon: "M15.536 8.464a5 5 0 010 7.072M12 6v12m0-12C10.343 6 8.828 6.828 7.757 8.1M12 18c1.657 0 3.172-.828 4.243-2.1",
                desc: "No notifications. No streaks. No pressure. Just presence.",
              },
            ].map((item) => (
              <div key={item.title} className="bg-white border border-slate-200 rounded-2xl p-7 text-center">
                <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center mx-auto mb-5">
                  <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold mb-3">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-7">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How ILO Works */}
      <section className="bg-white border-t border-slate-200">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="text-center mb-12">
            <p className="text-amber-600 uppercase tracking-[0.2em] text-xs font-semibold mb-3">How ILO Works</p>
            <h2 className="text-3xl md:text-4xl font-light mb-5">Adaptive intelligence. Lightweight. Real-time.</h2>
            <p className="text-slate-600 leading-8 max-w-2xl mx-auto">
              ILO functions as a software-based chatbot within a mobile and digital application
              environment, operating through a lightweight interface and adaptive intelligence engine.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            {[
              { point: "Responds in real-time to user state", icon: "M13 10V3L4 14h7v7l9-11h-7z" },
              { point: "Enables short, focused clarity sessions", icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" },
              { point: "Functions without storing personal data", icon: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" },
              { point: "Delivers a distraction-free experience", icon: "M5 3l14 9-14 9V3z" },
            ].map((item) => (
              <div key={item.point} className="flex items-center gap-4 bg-white border border-slate-200 rounded-xl px-6 py-4">
                <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                  </svg>
                </div>
                <p className="text-slate-700 text-sm leading-6">{item.point}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 bg-white border border-amber-200 rounded-xl px-6 py-4">
            <p className="text-slate-600 text-sm leading-7">
              <span className="text-amber-600 font-semibold">Integration: </span>
              ILO is integrated within the PAUS application and can be accessed seamlessly for immediate use.
            </p>
          </div>
        </div>
      </section>

      {/* Who is ILO for */}
      <section className="bg-[#f6f9fc] border-t border-slate-200">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-20 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-amber-600 uppercase tracking-[0.2em] text-xs font-semibold mb-3">Who is ILO for?</p>
            <h2 className="text-3xl md:text-4xl font-light mb-6">
              For anyone seeking mental clarity and inner balance
            </h2>
            <p className="text-slate-600 leading-8">
              ILO supports well-being through simplicity, stillness, and awareness.
              It works because it doesn't add more to your mind — it removes what's already in the way.
            </p>
          </div>
          <div className="space-y-3">
            {[
              "When thoughts feel overwhelming",
              "When focus is scattered",
              "When you need a quick mental reset",
              "When traditional methods feel too heavy or structured",
            ].map((point) => (
              <div key={point} className="flex items-start gap-3 bg-white border border-slate-200 rounded-xl px-5 py-4">
                <div className="w-5 h-5 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-amber-400/80" />
                </div>
                <p className="text-slate-700 text-sm leading-6">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technology */}
      <section className="bg-white border-t border-slate-200">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="text-center mb-12">
            <p className="text-amber-600 uppercase tracking-[0.2em] text-xs font-semibold mb-3">Technology & Platform</p>
            <h2 className="text-3xl md:text-4xl font-light mb-5">Built for scale. Designed for simplicity.</h2>
            <p className="text-slate-600 leading-8 max-w-2xl mx-auto">
              ILO is built as an intelligent chatbot experience within the PAUS platform,
              leveraging advanced language models and Open API integrations.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-5">
            {[
              { title: "Adaptive AI Intelligence", desc: "Powered through external AI APIs with adaptive conversational intelligence." },
              { title: "Human-Centered Design", desc: "Interaction design focused on simplicity and ease of use." },
              { title: "Scalable Architecture", desc: "Integrated within the PAUS ecosystem for individuals and organizations globally." },
              { title: "Privacy-First Implementation", desc: "Secure, minimal data handling ensuring your privacy at every session." },
            ].map((item) => (
              <div key={item.title} className="bg-white border border-slate-200 rounded-2xl p-6">
                <h3 className="text-base font-semibold text-amber-600 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-7">{item.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-6">
            <p className="text-sm font-semibold text-white mb-4">Part of the PAUS Digital Ecosystem</p>
            <div className="flex flex-wrap gap-3">
              {["Subscription-based clarity sessions", "PAUS application integration", "Digital distribution across PAUS platforms", "Scalable for individuals & organizations"].map((f) => (
                <span key={f} className="bg-amber-50 border border-amber-200 text-amber-600 text-xs px-4 py-2 rounded-full">{f}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#f6f9fc] border-t border-slate-200">
        <div className="max-w-3xl mx-auto px-6 md:px-10 py-20 text-center">
        <img src="/ilo 01 png.png" alt="ILO" className="h-20 w-auto object-contain mx-auto mb-6 rounded-lg opacity-80" />
          <h2 className="text-3xl md:text-4xl font-light mb-3">Ready to experience ILO?</h2>
          <p className="text-slate-500 text-sm mb-8">No memory. No data. No advice.</p>
          <Link
            to="/#contact"
            className="inline-block bg-amber-500 text-white font-semibold px-8 py-3 rounded-xl hover:opacity-90 transition"
          >
            Contact Us to Get Started
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#f6f9fc] border-t border-slate-200 text-slate-500">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm">
          <div className="flex items-center gap-3">
            <img src="/White ilo.jpg" alt="ILO" className="h-6 w-auto object-contain rounded" />
            <p>© {currentYear} ILO. A product of <span className="text-amber-600">M3 Global Medicare LLP</span>.</p>
          </div>
          <Link to="/" className="hover:text-amber-600 transition-colors">← Back to M3 Global</Link>
        </div>
      </footer>
    </div>
  );
}